import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import Pager from "../../../src/View/UI/Pager/Pager";
import ActionPlanList from "./actionPlanList";
export default class ActionPlanIndex extends Component {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        this.onData = (data) => {
            if (data.totalCount) {
                this.setState({ totalCount: data.totalCount });
            }
        };
        this.state = {
            page: 0,
            max: 10,
        };
    }
    render() {
        return (_jsxs(Fragment, { children: [_jsx("content", { tag: "secondaryNavbar", children: _jsx("div", { className: "navbar-secondarynav fixed fit-to-parent border-right", role: "navigation", style: { width: "100%" }, children: _jsxs("a", { href: "/aviso/app/admin/taskAdmin/actionplan/create", className: "btn btn-link", title: "new", children: [_jsx("span", { className: "fa fa-plus" }), " New"] }) }) }), _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsx("h1", { className: "title", children: "Action Plan Templates" }) }) }), _jsxs("div", { role: "main", children: [_jsx(ActionPlanList, { params: { page: this.state.page + 1, max: this.state.max }, onData: this.onData }), _jsx(Pager, { currentPage: this.state.page, setCurrentPage: (page) => this.setState({ page }), totalPages: Math.ceil(this.state.totalCount / this.state.max) })] })] })] }));
    }
}
